
export const MY_TASKS_CURRENT_VIEW_SET = 'MY-TASKS:currentViewSet'